<template>
  <div class="">
    <div class="form-group">
      <label :for="`attribute_${attribute.id}`">{{ attribute.title }} ({{
          translateRequiredValue(attribute.required)
        }})</label>
      <input :required="attribute.required" :placeholder="attribute.placeholder" v-model="inputValue" type="text"
             :id="`attribute_${attribute.id}`"
             class="form-control">
    </div>

  </div>
</template>

<script>

export default {
  name: "BasalamAttribute",
  props: {
    attribute: {
      default: null
    },
    basalamProduct: {
      default: null
    }
  },
  data() {
    return {
      inputValue: ''
    }
  },
  computed: {
    productAttributes() {
      return this.basalamProduct.revision.data.product_attribute
    },
    attributeValue() {
      let attributeValue = this.productAttributes.find((item) => {
        return item.id == this.attribute.id
      })
      return attributeValue == undefined ? '' : attributeValue.value
    }
  },
  methods: {
    translateRequiredValue(attribute) {
      return attribute.required ? 'اجباری' : 'اختیاری'
    }
  },
  mounted() {
    if(this.basalamProduct != null){
      this.inputValue = this.attributeValue
    }
  }
}
</script>


<style scoped>

</style>